import { render, staticRenderFns } from "./dh-ventura.vue?vue&type=template&id=ad33a39c&"
import script from "./dh-ventura.vue?vue&type=script&lang=js&"
export * from "./dh-ventura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports